import React, { useEffect } from 'react'
import { Route, Routes, useLocation } from 'react-router-dom'
import PublicRoute from './router/publicRoutes'
import PrivateRoute from './router/privateRoutes'
import { authRoutes, unAuthRoutes } from './router/routes'
import Layout from './layout'
import { scrollGoToTop } from './helper/function'

const AppContainer = () => {
  const location = useLocation()
  const isDirectLoad = window.performance && window.performance.navigation.type === 0

  useEffect(() => {}, [isDirectLoad])

  useEffect(() => {
    scrollGoToTop()
  }, [location])

  return (
    <>
      <Routes>
        {unAuthRoutes?.map((route, idx) => (
          <Route key={idx} path={route?.path} element={<PublicRoute>{route?.element}</PublicRoute>} />
        ))}
        <Route element={<Layout />}>
          {authRoutes?.map((route, idx) => (
            <Route key={idx} path={route?.path} element={<PrivateRoute>{route?.element}</PrivateRoute>} />
          ))}
        </Route>
      </Routes>
    </>
  )
}

export default AppContainer
